import { signInWithWorkspaceEmail } from '../centralIdentityAuth';
import { authFetch } from '../../../shared/api/authFetch';
import { setViewAs } from '../../../shared/api/viewAsSession';
import { admin_apiConfig } from '../../../shared/config/config';
import {
  getAccessSession,
  signOutAccessSession,
  subscribeAuthState,
} from '../sessionAccess';

const inferRoleFromUser = (user) =>
  user?.app_metadata?.role ||
  null;

// Session management
export async function getSession() {
  return getAccessSession();
}

export async function getCurrentUser() {
  const session = await getAccessSession();
  return session?.user || null;
}

export async function refreshSession() {
  return getAccessSession({ forceRefresh: true });
}

async function getUserRole(userId) {
  if (!userId) {
    return null;
  }

  try {
    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error('getUserRole timeout')), 5000)
    );

    const response = await Promise.race([
      authFetch(`${admin_apiConfig.baseURL}/api/organization/me`),
      timeoutPromise,
    ]);
    if (!response.ok) return null;
    const body = await response.json();
    return body?.role_slug || null;
  } catch (error) {
    return null;
  }
}

export async function signInWithPassword(email, password) {
  const session = await signInWithWorkspaceEmail(email, password);
  return { session, role: await getUserRole(session?.user?.id) };
}

export async function signOut(queryClient = null) {
  await signOutAccessSession();
  setViewAs(null);

  if (queryClient) {
    queryClient.clear();
  }

  const keysToRemove = ['authToken', 'userData', 'wizardProgress'];

  keysToRemove.forEach((key) => {
    localStorage.removeItem(key);
  });

  const cachePrefixes = ['react-query', 'query-cache', 'cache-'];
  for (let i = localStorage.length - 1; i >= 0; i -= 1) {
    const key = localStorage.key(i);
    if (key && cachePrefixes.some((prefix) => key.startsWith(prefix))) {
      localStorage.removeItem(key);
    }
  }

  window.location.href = '/login';
}

export function onAuthStateChange(callback) {
  return subscribeAuthState(callback);
}

export function getErrorMessage(error) {
  switch (error.message) {
    case 'Invalid login credentials':
      return 'Invalid email or password';
    case 'Email not confirmed':
      return 'Please verify your email address';
    case 'Email already registered':
      return 'An account with this email already exists';
    case 'Password should be at least 12 characters':
      return 'Password must be at least 12 characters long';
    case 'User already registered':
      return 'An account with this email already exists. Please sign in instead.';
    default:
      return 'An unexpected error occurred. Please try again.';
  }
}
